"use strict";
(self["webpackChunkshop_chunks"] = self["webpackChunkshop_chunks"] || []).push([[148],{

/***/ 148:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CreatorVideo)
/* harmony export */ });
if (!customElements.get('gif-component')) {
  customElements.define(
    'gif-component',
    class CustomDialog extends HTMLElement {
      constructor() {
        super()
        this.playButton = this.querySelector('button')
        this.togglePlay = this.togglePlay.bind(this)
        this.playButton.addEventListener('click', this.togglePlay)
      }

      togglePlay() {
        const { playButton } = this
        const isPlaying = this.dataset.isPlaying === 'true'
        if (!isPlaying) {
          this.dataset.isPlaying = 'true'
        } else {
          this.dataset.isPlaying = 'false'
        }
      }
    }
  )
}

function CreatorVideo() {
  return null
}


/***/ })

}]);